module.exports = __webpack_public_path__ + "media/application/images/svgs/edit-8e806c039fecb38c56193f163466b08b.svg";